import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect } from "react";
import { TemplateType } from "./types";

interface TemplateContextProps {
  listaTemplate: TemplateType[];
  setListaTemplate: Dispatch<SetStateAction<TemplateType[]>>
}

export const TemplateContext = createContext({} as TemplateContextProps);

export function TemplateProvider({ children }: { children: ReactElement }) {
  const [listaTemplate, setListaTemplate] = useState<TemplateType[]>([] as TemplateType[]); 

  return (
      <TemplateContext.Provider
        value={{
          listaTemplate,
          setListaTemplate,
        }}
      >
          {children}
      </TemplateContext.Provider>
  );
}
